import { Component } from '@angular/core';

@Component({
    selector: 'left-arrow-svg',
    templateUrl: './left-arrow.component.svg',
})
export class LeftArrowComponent { }
